<div class="teams-rules">
  @if ((rules$ | async); as rules) {
    <div class="teams-rule-list">
      @for (rule of rules; track rule) {
        <article class="teams-rule-row">
          <div class="teams-rule-main">
            <div class="teams-rule-title">{{ this.getRuleTitle(rule) }}</div>
            <div class="teams-rule-meta">{{ this.getRuleFrequencyLabel(rule) }}</div>
          </div>
          <div class="teams-rule-status" [class.is-disabled]="rule.disabled">{{ this.getRuleStatusLabel(rule) }}</div>
          <div class="teams-rule-last-ran">{{ this.getRuleLastRanLabel(rule) }}</div>
          <div class="teams-rule-actions">
            <button type="button" class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors" (click)="editRule(rule)">Edit</button>
            <button type="button" class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors" (click)="deleteRule(rule)">Delete</button>
          </div>
        </article>
      }
      @if (rules.length === 0) {
        <div class="teams-rule-empty">No monitoring rules have been configured yet.</div>
      }
    </div>
  }
</div>
<ng-template #templateForm>
  <form class="k-form k-form-md" [formGroup]="form" #formControl>

    <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
      <kendo-formfield style="flex:1">
        <label class="block text-sm font-medium text-gray-700 mb-1" [for]="typeList">Report</label>
        <kendo-dropdownlist #typeList [data]="['Flow Runs', 'Flow Summary']" formControlName="type">
        </kendo-dropdownlist>
      </kendo-formfield>
      <kendo-formfield style="flex:1">
        <label class="block text-sm font-medium text-gray-700 mb-1" [for]="toggleSwitch">Enabled</label>
        <kendo-switch
          #toggleSwitch
          formControlName="enabled">
        </kendo-switch>
      </kendo-formfield>
    </div>

    <kendo-formfield>
      <label class="block text-sm font-medium text-gray-700 mb-1" [for]="frequencyList">Repeats</label>
      <kendo-dropdownlist #frequencyList [data]="['Daily', 'Weekly']" formControlName="repeat">
      </kendo-dropdownlist>

    </kendo-formfield>

    <kendo-formfield>
      <label class="block text-sm font-medium text-gray-700 mb-1" [for]="email">Email To</label>
      <input kendoTextBox #email type="text" formControlName="email"
        >
      </kendo-formfield>

      @if (frequencyList.value == 'Weekly') {
        <kendo-formfield showHints="always">
          <kendo-multiselect
            formControlName="on"
            [data]="this.days"
            textField="text"
            valueField="value"
          ></kendo-multiselect>
          <kendo-formhint
            >Select the days when you want this rule to run</kendo-formhint
            >
          </kendo-formfield>
        }

        <div style="display: flex; justify-content: space-between; align-items: flex-end; gap: 8px;">
          <kendo-formfield style="flex:1;">
            <label class="block text-sm font-medium text-gray-700 mb-1" [for]="startInput">Start (optional)</label>

            <kendo-timepicker #startInput required [steps]="steps" [allowCaretMode]="true" formControlName="startTime">
            </kendo-timepicker>

          </kendo-formfield>

          <div style="flex:1;">
            @if ((startTimeUTC$ | async); as st) {
              <label class="k-form-label">
                UTC Time: {{ st }}
              </label>
            }
          </div>
        </div>

      </form>
    </ng-template>
